const stripQuotes = (value: string) => value.replace(/^['"]|['"]$/g, "");

function getEnvValue(viteKey: string): string {
  const win =
    typeof window !== "undefined" ? (window as unknown as { env?: Record<string, unknown> }).env : undefined;
  if (win && win[viteKey]) {
    const s = String(win[viteKey]);
    if (s && !s.includes("${")) return stripQuotes(s);
  }
  const v = (import.meta.env as Record<string, string | undefined>)[viteKey];
  return v ? stripQuotes(v) : "";
}

export const REACT_APP_BASE_PATH =
  getEnvValue("VITE_BASE_PATH") || "http://localhost:8090/support/v1";
